import { render, staticRenderFns } from "./AddClinic.vue?vue&type=template&id=7467d200&scoped=true"
import script from "./AddClinic.vue?vue&type=script&lang=js"
export * from "./AddClinic.vue?vue&type=script&lang=js"
import style0 from "./AddClinic.vue?vue&type=style&index=0&id=7467d200&prod&lang=scss&scoped=true"
import style1 from "./AddClinic.vue?vue&type=style&index=1&id=7467d200&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7467d200",
  null
  
)

export default component.exports